module.exports = __webpack_public_path__ + "static/img/cooper_6.ccf0b5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/posters-desktop/cooper_6.jpg
// module id = WSeS
// module chunks = 1